export default __webpack_public_path__ + "static/media/Leggings of the Unslaked.bf4863c9.jpg";